<template>
    <div class="login-container">
        <!-- 顶部标题栏 -->
        <div class="header">
            <div class="logo">
                <span class="logo-text">移动网络接入认证</span>
            </div>
            <div class="login-title">手机号认证上网</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="login-content">
            <div class="login-card">
                <h2 class="card-title">手机号认证</h2>
                <div class="tips">
                    <i class="el-icon-info"></i>
                    请输入您的手机号码获取验证码，完成认证后即可上网
                </div>

                <el-form :model="form" :rules="rules" ref="formRef">
                    <!-- 手机号输入 -->
                    <div class="form-item">
                        <label class="form-label">手机号码</label>
                        <el-form-item prop="phone">
                            <el-input
                                    v-model="form.phone"
                                    placeholder="请输入手机号码"
                                    maxlength="11"
                                    clearable
                                    size="large">
                                <i slot="prefix" class="el-icon-mobile-phone"></i>
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 验证码输入 -->
                    <div class="form-item">
                        <label class="form-label">验证码</label>
                        <el-form-item prop="code">
                            <div class="code-input">
                                <el-input
                                        v-model="form.code"
                                        placeholder="请输入验证码"
                                        maxlength="6"
                                        clearable
                                        size="large">
                                    <i slot="prefix" class="el-icon-key"></i>
                                </el-input>
                                <el-button
                                        class="get-code-btn"
                                        :class="{ 'is-disabled': codeDisabled }"
                                        :disabled="codeDisabled"
                                        :loading="codeLoading"
                                        @click="getCode">
                                    {{ codeText }}
                                </el-button>
                            </div>
                        </el-form-item>
                    </div>

                    <!-- 登录按钮 -->
                    <el-button
                            type="primary"
                            class="login-btn"
                            :loading="loading"
                            @click="submitForm">
                        立即认证上网
                    </el-button>
                </el-form>

                <div class="agreement">
                    点击"立即认证上网"即表示您已阅读并同意
                    <a href="#" @click.prevent="showAgreement">《网络使用协议》</a>和
                    <a href="#" @click.prevent="showPrivacy">《隐私政策》</a>
                </div>
            </div>
        </div>

        <!-- 底部信息 -->
        <div class="footer">
            <p>© 2026 网络服务提供商 版权所有</p>
        </div>
    </div>
</template>

<script>
    import {sendSmsCode} from '../api/oneLinkAuth'
    import myzxios from '../utils/myaxios'

    export default {
        name: 'Auth',
        data() {
            const validatePhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入手机号码'));
                } else if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            };

            const validateCode = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入验证码'));
                } else if (!/^\d{6}$/.test(value)) {
                    callback(new Error('验证码为6位数字'));
                } else {
                    callback();
                }
            };

            return {
                iccid: '',           // 从路由参数获取的设备号
                mac: '',             // 设备MAC地址
                terminalMac: '',     // 终端MAC地址
                imei: '',            // 设备IMEI
                codeToken: '',       // 认证成功后返回的codeToken
                form: {
                    phone: '',
                    code: ''
                },
                rules: {
                    phone: [
                        { validator: validatePhone, trigger: 'blur' }
                    ],
                    code: [
                        { validator: validateCode, trigger: 'blur' }
                    ]
                },
                loading: false,
                codeDisabled: false,
                codeLoading: false,
                codeText: '获取验证码',
                countdown: 60,
                timer: null
            }
        },

        created() {
            // 从路由参数获取iccid
            this.iccid = this.$route.query.iccid || '';

            // 获取设备信息（实际项目中需要从设备获取或后端传递）
            this.mac = this.$route.query.mac || '';
            this.terminalMac = this.$route.query.terminalMac || '';
            this.imei = this.$route.query.imei || '';

            console.log('认证页面初始化:', {
                iccid: this.iccid,
                mac: this.mac,
                terminalMac: this.terminalMac,
                imei: this.imei
            });

            if (!this.iccid) {
                this.$message.warning('设备号信息缺失，请返回重新查询');
                setTimeout(() => {
                    this.$router.push('/queryIccid');
                }, 3000);
            }
        },

        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },

        methods: {
            // 获取验证码
            getCode() {
                this.$refs.formRef.validateField('phone', (error) => {
                    if (!error) {
                        if (!this.iccid) {
                            this.$message.error('设备号信息缺失，请返回重新查询');
                            return;
                        }

                        // 验证手机号是否与设备绑定（可选）
                        this.checkPhoneAndDevice();
                    }
                });
            },

            // 检查手机号与设备的绑定关系
            checkPhoneAndDevice() {
                this.codeLoading = true;

                const params = {
                    phoneNum: this.form.phone,
                    iccid: this.iccid,
                    mac: this.mac,
                    terminalMac: this.terminalMac
                };

                console.log('发送验证码请求:', params);

                sendSmsCode(params)
                    .then((res) => {
                        this.codeLoading = false;
                        console.log('发送验证码响应:', res);

                        if (res.data && (res.data.code === '0' || res.data.code === 0)) {
                            this.$message.success(res.data.message || '验证码已发送到您的手机');
                            this.startCountdown();
                        } else {
                            this.$message.error(res.data.message || '发送验证码失败，请稍后重试');
                        }
                    })
                    .catch((error) => {
                        this.codeLoading = false;
                        console.error('发送验证码失败', error);
                        let errorMsg = '发送验证码失败，请检查网络后重试';
                        if (error.response && error.response.data) {
                            errorMsg = error.response.data.message || errorMsg;
                        }
                        this.$message.error(errorMsg);
                    });
            },

            // 开始倒计时
            startCountdown() {
                this.codeDisabled = true;
                this.codeText = `${this.countdown}秒后重新获取`;

                this.timer = setInterval(() => {
                    this.countdown--;
                    this.codeText = `${this.countdown}秒后重新获取`;

                    if (this.countdown <= 0) {
                        clearInterval(this.timer);
                        this.codeDisabled = false;
                        this.codeText = '获取验证码';
                        this.countdown = 60;
                        this.timer = null;
                    }
                }, 1000);
            },

            // 提交表单 - 终端认证
            submitForm() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.doTerminalAuth();
                    } else {
                        this.$message.error('请正确填写表单');
                        return false;
                    }
                });
            },

            // 执行终端认证
            doTerminalAuth() {
                const params = {
                    verifyCode: this.form.code,
                    phoneNum: this.form.phone,
                    iccid: this.iccid,
                    mac: this.mac,
                    terminalMac: this.terminalMac
                };

                console.log('终端认证请求:', params);

                myzxios({
                    url: '/manager/oneLinkAuth/terminalAuth',
                    data: params,
                    method: 'POST'
                })
                    .then((res) => {
                        console.log('终端认证响应:', res);

                        if (res.data && (res.data.code === '0' || res.data.code === 0)) {
                            // 认证成功，获取codeToken
                            this.codeToken = res.data.data.codeToken;
                            this.$message.success('验证成功，正在接入网络...');

                            // 执行终端上线
                            this.doTerminalOnline();
                        } else {
                            this.loading = false;
                            this.$message.error(res.data.message || '验证码错误，请重新输入');
                            // 清空验证码输入框
                            this.form.code = '';
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error('终端认证失败', error);
                        let errorMsg = '认证失败，请稍后重试';
                        if (error.response && error.response.data) {
                            errorMsg = error.response.data.message || errorMsg;
                        }
                        this.$message.error(errorMsg);
                        this.form.code = '';
                    });
            },

            // 执行终端上线
            doTerminalOnline() {
                const params = {
                    codeToken: this.codeToken,
                    iccid: this.iccid,
                    imei: this.imei,
                    mac: this.mac,
                    terminalMac: this.terminalMac
                };

                console.log('终端上线请求:', params);

                myzxios({
                    url: '/manager/oneLinkAuth/terminalOnline',
                    data: params,
                    method: 'POST'
                })
                    .then((res) => {
                        this.loading = false;
                        console.log('终端上线响应:', res);

                        if (res.data && (res.data.code === '0' || res.data.code === 0)) {
                            this.$message.success('认证成功，网络已接入');

                            // 保存认证状态
                            localStorage.setItem('auth_status', 'success');
                            localStorage.setItem('auth_iccid', this.iccid);
                            localStorage.setItem('auth_time', new Date().toISOString());

                            // 跳转到成功页面
                            setTimeout(() => {
                                this.$router.push('/success');
                            }, 1500);
                        } else {
                            this.$message.error(res.data.message || '网络接入失败，请稍后重试');
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error('终端上线失败', error);
                        this.$message.error('网络接入失败，请稍后重试');
                    });
            },

            // 显示使用协议
            showAgreement() {
                this.$alert('这里是网络使用协议内容...', '网络使用协议', {
                    confirmButtonText: '确定',
                    customClass: 'agreement-modal'
                });
            },

            // 显示隐私政策
            showPrivacy() {
                this.$alert('这里是隐私政策内容...', '隐私政策', {
                    confirmButtonText: '确定',
                    customClass: 'agreement-modal'
                });
            }
        }
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    /* 移动端基础设置 */
    html, body {
        font-size: 16px;
        -webkit-tap-highlight-color: transparent;
    }

    .login-container {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        position: relative;
    }

    .header {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
        background: rgba(0, 0, 0, 0.2);
    }

    .logo {
        display: flex;
        align-items: center;
    }

    .logo-text {
        font-size: 18px;
        font-weight: 500;
    }

    .login-title {
        font-size: 16px;
        font-weight: 500;
    }

    .login-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        min-height: calc(100vh - 120px);
    }

    .login-card {
        width: 100%;
        max-width: 500px;
        background: white;
        border-radius: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        padding: 40px 30px;
        margin: 0 auto;
        transition: all 0.3s ease;
    }

    /* 移动端适配 */
    @media (max-width: 480px) {
        .login-card {
            padding: 30px 24px;
        }

        .card-title {
            font-size: 24px;
            margin-bottom: 20px;
        }
    }

    @media (max-width: 380px) {
        .login-card {
            padding: 24px 18px;
        }

        .card-title {
            font-size: 22px;
        }
    }

    .card-title {
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 24px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .form-item {
        margin-bottom: 24px;
    }

    .form-label {
        display: block;
        margin-bottom: 10px;
        font-size: 15px;
        color: #333;
        font-weight: 600;
    }

    /* 移动端输入框放大优化 */
    .form-item >>> .el-input {
        font-size: 16px !important;
    }

    .form-item >>> .el-input__inner {
        height: 52px !important;
        line-height: 52px !important;
        font-size: 18px !important;
        padding: 0 40px 0 42px !important;
        border-radius: 12px !important;
        border: 1px solid #e0e4e8 !important;
        transition: all 0.3s ease;
    }

    .form-item >>> .el-input__inner:focus {
        border-color: #667eea !important;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
    }

    /* 输入框前缀图标放大 */
    .form-item >>> .el-input__prefix {
        left: 16px !important;
        font-size: 20px !important;
    }

    .form-item >>> .el-input__prefix i {
        font-size: 20px !important;
        line-height: 52px !important;
    }

    /* 验证码输入区域 */
    .code-input {
        display: flex;
        gap: 12px;
        align-items: center;
    }

    .code-input .el-input {
        flex: 1;
    }

    /* 验证码按钮优化 */
    .get-code-btn {
        min-width: 120px;
        height: 52px !important;
        line-height: 52px !important;
        font-size: 15px !important;
        font-weight: 500;
        border-radius: 12px !important;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        color: white;
        transition: transform 0.2s, opacity 0.2s;
    }

    .get-code-btn:active {
        transform: scale(0.97);
    }

    .get-code-btn.is-disabled {
        background: #c0c4cc !important;
        opacity: 0.8;
    }

    /* 移动端适配验证码按钮 */
    @media (max-width: 380px) {
        .code-input {
            flex-direction: column;
            gap: 12px;
        }

        .get-code-btn {
            width: 100%;
            min-width: auto;
        }
    }

    /* 登录按钮优化 */
    .login-btn {
        width: 100%;
        height: 56px !important;
        font-size: 18px !important;
        font-weight: 600;
        margin-top: 16px;
        margin-bottom: 0;
        border-radius: 28px !important;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        transition: transform 0.2s, box-shadow 0.2s;
    }

    .login-btn:active {
        transform: scale(0.98);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }

    /* 协议区域 */
    .agreement {
        margin-top: 20px;
        font-size: 13px;
        color: #666;
        text-align: center;
        line-height: 1.5;
    }

    .agreement a {
        color: #667eea;
        text-decoration: none;
        font-weight: 500;
    }

    .footer {
        padding: 20px;
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
        font-size: 12px;
    }

    /* 提示框优化 */
    .tips {
        background: #f0f7ff;
        border-radius: 12px;
        padding: 14px 18px;
        margin-bottom: 32px;
        font-size: 14px;
        color: #409eff;
        border-left: 4px solid #409eff;
        display: flex;
        align-items: center;
        line-height: 1.4;
    }

    .tips i {
        margin-right: 10px;
        font-size: 18px;
        flex-shrink: 0;
    }

    /* 表单校验错误信息优化 */
    .form-item >>> .el-form-item__error {
        font-size: 13px;
        padding-top: 6px;
        color: #f56c6c;
    }

    /* 大屏设备适配 */
    @media (min-width: 768px) {
        .login-card {
            max-width: 550px;
            padding: 45px 40px;
        }

        .form-item >>> .el-input__inner {
            height: 56px !important;
            line-height: 56px !important;
        }

        .get-code-btn {
            height: 56px !important;
            line-height: 56px !important;
        }

        .login-btn {
            height: 58px !important;
        }
    }
</style>

<style>
    /* 全局样式调整 */
    .agreement-modal {
        width: 90%;
        max-width: 500px;
        border-radius: 16px;
    }

    .agreement-modal .el-message-box__header {
        padding: 20px 20px 10px;
    }

    .agreement-modal .el-message-box__content {
        padding: 10px 20px 20px;
        max-height: 60vh;
        overflow-y: auto;
        line-height: 1.6;
        color: #333;
    }

    .agreement-modal .el-message-box__btns {
        padding: 10px 20px 20px;
    }

    .agreement-modal .el-button {
        border-radius: 24px;
        padding: 10px 24px;
    }
</style>